// Types
import { PracticeTestsChart } from './types';

// Services
import { gql } from 'graphql-request';
import { useQuery, UseQueryResult } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useGetTestsChart = (classId: number) => {
  const { client } = graphqlConfig();

  const data: UseQueryResult<PracticeTestsChart, Error> = useQuery<PracticeTestsChart, Error>(['test-chart'], async () => client.request(
    gql`
    query UserTestsChart($classId: Float!) {
      userTestsChart(classId: $classId) {
        marks
        names
      }
    }
    `,
    {
      classId
    }
  ).catch((error) => console.error(error)));
  return data;
};
